import { useSelector } from "react-redux";

// Administradores e desenvolvedores são identificados pelo nome do grupo do
// sistema, mesma regra usada em Atendimentos/ManageTickets.
export function isUsuarioAdmOuDesenvolvedor(usuario?: { gruposistema?: { nome?: string } | null }) {
  const nomeGrupo = usuario?.gruposistema?.nome?.toUpperCase() ?? "";
  return nomeGrupo.includes("ADM") || nomeGrupo.includes("DESENVOLVEDOR");
}

export function VerifyUserAdmOuDesenvolvedor() {
  const { user } = useSelector((state: any) => ({
    user: state.Auth.user,
  }));

  return isUsuarioAdmOuDesenvolvedor(user?.usuario);
}
